import i18n from '@/locales'

const ROLES = [
  'admin',
  'domainadmin',
  'project_owner',
  'domain_editor',
  'project_editor',
  'ai_admin',
  'ai_edtior',
  'ai_viewer',
]
export default {
  index: 60,
  meta: {
    label: i18n.t('llmops.llmops'),
    icon: 'res-suggestsalert',
    catalog: 'mlops',
  },
  menus: [
    {
      meta: {
        label: i18n.t('llmops.knowledgebase'),
        roles: ROLES,
      },
      submenus: [
        {
          path: '/llm/datasets',
          meta: {
            label: i18n.t('llmops.knowledgebase'),
            external: true,
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('llmops.appbuilder'),
        roles: ROLES,
      },
      submenus: [
        {
          path: '/llm/apps',
          meta: {
            label: i18n.t('llmops.appbuilder'),
          },
        },
      ],
    },
    {
      meta: {
        label: i18n.t('llmops.appmarket'),
        roles: ROLES,
      },
      submenus: [
        {
          path: '/llm/explore/apps',
          meta: {
            label: i18n.t('llmops.appmarket'),
          },
        },
      ],
    },
  ],
}
